<div class="page-title-area item-bg2">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="index.html" i18n>Home</a></li>
                <li i18n>Blog Details</li>
                <li></li>
            </ul>
            <h2 i18n>Blog Details</h2>
        </div>
    </div>
</div>

<div class="blog-details-area ptb-100" [class.dark-blog-details-area]="themeService.isDark()">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="blog-details-desc">
                    <div class="article-content">

                        <div class="entry-meta">
                            <ul>
                               
                                <li>
                                    <i class='bx bx-group'></i>
                                    <span i18n>AUTHOR</span>
                                    <a routerLink="/single-blog">{{blog?.author}}</a>
                                </li>
                                <li>
                                    <i class='bx bx-calendar'></i>
                                    <span i18n>PUBLISHED DATE</span>
                                    <a routerLink="/single-blog">{{blog?.created_at|date:'longDate'}}</a>
                                </li>
                            </ul>
                        </div>
                        <h3>{{blog?.title}}</h3>
                        
                        <p> {{blog?.text}}</p>
                        

                        <ul class="wp-block-gallery columns-3">
                            <li class="blocks-gallery-item" *ngFor="let img of blog?.images">
                                <figure>
                                    <img [src]="imageURL+img.url" alt="image">
                                </figure>
                            </li>
                           

                        </ul>


                    </div>

                </div>

            </div>
        </div>
    </div>